// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueSocketio from 'vue-socket.io'
import socketio from 'socket.io-client'
import vueTouch from 'vue-plugin-touch'
import "babel-polyfill";

// Vue.use(VueSocketio, 'http://192.168.0.91:8000')
// Vue.use(VueSocketio, socketio('http://192.168.0.91:8000'), store);
Vue.use(vueTouch)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
    store,
	template: '<App/>',
	components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js